export default __webpack_public_path__ + "static/media/sepia.a8e4a78f.png";